// Vendors
import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useUploadIdContextConsumerHook } from 'containers/upload-id/contexts/upload-id.context';
import { useAppContextConsumerHook } from 'contexts/app.context';
// Event Handlers
import { UploadIdVerificationHandlers } from '../handlers/upload-id-verification.handlers';
import { UploadIdVerificationTrackingHandlers } from '../handlers/upload-id-verification.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { UploadIdVerificationHookType } from './types/upload-id-verification.hook.type';

const useUploadIdVerificationHook = (): UploadIdVerificationHookType => {
  const [showLoader, setShowLoader] = useState(false);

  const { setUploadIdState, verificationInformation } = useUploadIdContextConsumerHook(),
    { setCurrentState, setOnHeaderBackClick } = useAppContextConsumerHook(),
    { url = '' } = verificationInformation || {};

  const { showBoundary: setError } = useErrorBoundary();

  const { handleTrackWebSocketError } = useAppTrackingHook(UploadIdVerificationTrackingHandlers);

  const { handleUpdateUploadIdHeaderBackClick, ...handlers } = UploadIdVerificationHandlers({
    handleTrackWebSocketError,
    setCurrentState,
    setError,
    setOnHeaderBackClick,
    setUploadIdState,
    setShowLoader,
  });

  useEffect(() => {
    handleUpdateUploadIdHeaderBackClick();

    return () => {
      setOnHeaderBackClick(null);
    };
  }, []);

  return {
    ...handlers,
    showLoader,
    url,
  };
};

export { useUploadIdVerificationHook };
